<div class="container-participantes">
  <div class="header" *ngIf="index === 0">
    <p class="header-user">Participantes</p>
    <p class="header-value">Investimento (R$)</p>
    <p class="header-value">% <span>de investimento</span></p>
  </div>
  <div class="container-card"
  [ngClass]="{
    'isEdit': isEdit
  }">
    <div class="user" *ngIf="!isEdit">
      <div class="photo">
        <img [src]="user && user.picture_url ? user.picture_url : '../../../assets/imgs/image-default.png'" alt="Foto" (error)="removePicture()" [ngClass]="{'nimg': !user.picture_url }">
      </div>
      <span class="name-user">{{ user.user_nickname }}</span><span class="user-super" *ngIf="user.leaders?.length"> ({{user.leaders[0].nickname}})</span>
    </div>
    <div class="investiments-label">
      <div class="value">
        <label *ngIf="!isEdit">Investimento (R$)</label>
        <p class="porcent" *ngIf="!isEdit">{{ user.participation_value | currency: 'BRL' }}</p>
      </div>
      <div class="percentage">
        <label *ngIf="!isEdit">% de investimento</label>
        <p class="porcent" *ngIf="!isEdit">{{ user.participation_percentage | number: '1.2-2' }}%</p>
      </div>
    </div>

    <div class="form-array" [formGroup]="formCard" *ngIf="isEdit">
      <div class="autocomplete-group">
        <app-lead-autocomplete
          [campaignId]="campaignId"
          class="user-name-control" 
          [data]="formCard"
          field="user_nickname" 
          (fieldUser)="setParticipant($event)"
          id="lead-user-autocomplete-{{index}}"
          [ngClass]="{ 'border-error': isRealtorError }"
          [isError]="isRealtorError"
          [participants]="participants?.value">
        </app-lead-autocomplete>
      </div>

      <div class="investiments">
        <div class="container-cp margin-right">
          <app-input
            (change)="validateValue($event.target.value)"
            class="user-percent full"
            [error]="isValueError"
            formControlName="participation_value"
            id="lead-user-value-{{index}}"
            (input)="removeCaracter($event)"
            isPrice="true"
            label="Investimento (R$)"
            [messageError]="valueErro"
            placeholder="R$">
          </app-input>
        </div>
        <div class="container-cp">
          <app-input
            class="user-percent"
            formControlName="participation_percentage"
            id="lead-user-percent-{{index}}"
            (input)="removeCaracter($event)"
            [isDisabled]="true"
            label="% de investimento"
            [ngClass]="{'full': index === 0}"
            placeholder="%"
            [toFixed]="2">
          </app-input>
        </div>
      </div>
    </div>

    <div class="button-group"
    *ngIf="editable"
    [ngClass]="{
      'pad-top': isEdit,
      'value-error': isValueError,
      'realtor-error': isRealtorError
    }">
      <button class="btn-clear-user" (click)="showDialog($event)" *ngIf="!isEdit">
        <div class="icon-name">
          <img src="assets/svgs/i_closed_red.svg" alt="Remover">
          <p>Remover</p>
        </div>
      </button>

      <button class="btn-clear-user" (click)="isEdit = true" *ngIf="!isEdit">
        <div class="icon-name edit">
          <img src="assets/svgs/pencil_edit.svg" alt="Editar">
          <p>Editar</p>
        </div>
      </button>

      <button class="btn-clear-user" (click)="closeEdit()" *ngIf="isEdit" [disabled]="!formCard.valid">
        <div class="icon-name cancel"
        [ngClass]="{ disabled: !formCard.valid }">
          <svg width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.00016 13.6666C3.31816 13.6666 0.333496 10.682 0.333496 6.99998C0.333496 3.31798 
            3.31816 0.333313 7.00016 0.333313C10.6822 0.333313 13.6668 3.31798 13.6668 6.99998C13.6668 
            10.682 10.6822 13.6666 7.00016 13.6666ZM7.00016 12.3333C8.41465 12.3333 9.77121 11.7714 
            10.7714 10.7712C11.7716 9.77102 12.3335 8.41447 12.3335 6.99998C12.3335 5.58549 11.7716 
            4.22894 10.7714 3.22874C9.77121 2.22855 8.41465 1.66665 7.00016 1.66665C5.58567 1.66665 
            4.22912 2.22855 3.22893 3.22874C2.22873 4.22894 1.66683 5.58549 1.66683 6.99998C1.66683 
            8.41447 2.22873 9.77102 3.22893 10.7712C4.22912 11.7714 5.58567 12.3333 7.00016 
            12.3333ZM7.00016 6.05731L8.8855 4.17131L9.82883 5.11465L7.94283 6.99998L9.82883 
            8.88531L8.8855 9.82865L7.00016 7.94265L5.11483 9.82865L4.1715 8.88531L6.0575 6.99998L4.1715 
            5.11465L5.11483 4.17131L7.00016 6.05731Z" fill="#EB194B"/>
          </svg>
          <p>Cancelar</p>
        </div>
      </button>

      <button class="btn-clear-user" (click)="submitChanges()" *ngIf="isEdit" [disabled]="isValueError || isRealtorError">
        <div class="icon-name confirm"
        [ngClass]="{ disabled: isValueError || isRealtorError }">
          <svg width="20" height="20" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.99935 11.8346C2.7776 11.8346 0.166016 9.22305 0.166016 6.0013C0.166016 2.77955
            2.7776 0.167969 5.99935 0.167969C9.2211 0.167969 11.8327 2.77955 11.8327 6.0013C11.8327 
            9.22305 9.2211 11.8346 5.99935 11.8346ZM5.99935 10.668C7.23703 10.668 8.42401 10.1763 9.29918 
            9.30113C10.1744 8.42596 10.666 7.23898 10.666 6.0013C10.666 4.76363 10.1744 3.57664 9.29918 
            2.70147C8.42401 1.8263 7.23703 1.33464 5.99935 1.33464C4.76167 1.33464 3.57469 1.8263 2.69952 
            2.70147C1.82435 3.57664 1.33268 4.76363 1.33268 6.0013C1.33268 7.23898 1.82435 8.42596 2.69952 
            9.30113C3.57469 10.1763 4.76167 10.668 5.99935 10.668ZM5.41777 8.33464L2.94268 5.85955L3.76752 
            5.03472L5.41777 6.68497L8.7171 3.38505L9.54252 4.20989L5.41777 8.33464Z"/>
          </svg>
          <p>Confirmar</p>
        </div>
      </button>
    </div>
  </div>
</div>